// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609070604/js/" + chunkId + "." + {"44":"42a66360","225":"68963013","481":"295e2fca","486":"e4f81505","770":"a9754e7f"}[chunkId] + ".0.34841362891510275.chunk.js";
};